import React, { Component } from 'react';

class Nav extends Component {
  handleLogout(e){
    e.preventDefault();
    fetch('/api/logout', {credentials: 'include', method: 'POST'})
      .then(()=>{
        this.props.clearUser();
        window.location.href='#/';
      })
  }

  closeMenu(){
    window.hideNav();
  }

  render() {
    var qsa = navigator.standalone || window.location.search.indexOf('standalone') > -1;
    var navClass = "navbar navbar-inverse navbar-fixed-top";
    if(this.props.page === 'home')
      navClass += ' navbar-home';
    return (
      <nav className={navClass}>
          <div className="container-fluid">

            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed float-left" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a className="navbar-brand float-left" href="#/">My School Lunch</a>
            </div>


            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
              <ul className="nav navbar-nav">
                <li className={['home','dashboard'].indexOf(this.props.page) > -1 ? "active" : ''}>
                  <a href="#/" onClick={this.closeMenu()}>Home</a>
                </li>

                {
                  this.props.admin ? (
                    <li className={
                        "dropdown" + (
                          ['admin','report','ipad'].indexOf(this.props.page) > -1 ?
                            " active" : '')
                      }>
                      <a href="" className="dropdown-toggle"
                        data-toggle="dropdown"
                        role="button"
                        aria-haspopup="true"
                        aria-expanded="false">
                          Admin <span className="caret"></span>
                      </a>
                      <ul className="dropdown-menu">
                        <li><a href="#/admin" onClick={this.closeMenu()}>Admin</a></li>
                        <li role="separator" className="divider"></li>
                        <li><a href="#/ipad" onClick={this.closeMenu()}>Coffee Manager</a></li>
                        <li role="separator" className="divider"></li>
                        <li><a target={qsa?'browser':''}
                          href={qsa?"/browser.html#/report":'#/report'}>Print Orders</a></li>
                        <li role="separator" className="divider"></li>
                        <li><a href="/api/report" download>Download Lunch CSV</a></li>
                        <li role="separator" className="divider"></li>
                        <li><a href="/api/report/coffee" download>Download Coffee CSV</a></li>
                      </ul>
                    </li>
                  ) : null
                }

                <li className="dropdown">
                  <a href="" className="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false">
                      Contact Us <span className="caret"></span>
                  </a>
                  <ul className="dropdown-menu">
                    <li><a href="mailto:billie@myschoollunch.co.nz?subject=General Enquiry"
                      onClick={this.closeMenu()}>General Enquiry</a></li>
                    <li role="separator" className="divider"></li>
                    <li><a href="mailto:billie@myschoollunch.co.nz?subject=Refund Enquiry"
                      onClick={this.closeMenu()}>Refunds</a></li>
                  </ul>
                </li>

                <li><a href="#/logout" onClick={this.handleLogout.bind(this)}>Log out</a></li>
              </ul>
              { this.props.testMode ? (
                <span className="btn btn-danger pull-right" style={{marginTop:'8px'}}>Test Mode</span>
              ) : null }
            </div>
          </div>
        </nav>
    );
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/pages/components/Nav.js